import {useEffect} from "react"
import TeamManagementHeader from "../sections/team-management-header/TeamManagementHeader"
import TeamManagementContent from "../sections/team-management-content/TeamManagementContent"
import ConfirmationModal from "../components/confirmation-modal/ConfirmationModal"
import axios from "axios"
import {API_TEAMS} from "../constants/apiUrls"
import RequireIsManager from "../tools/RequireIsManager"
import {useTranslation} from "react-i18next"
import {toast} from "react-toastify"
import {useNavigate} from "react-router-dom"
import {useSessionContext} from "../reactContext/contextCustomHooks/useSessionContext"
import {useTeamContext} from "../reactContext/contextCustomHooks/useTeamContext"
import useTeam from "../swrCustomHooks/useTeam"

export default function TeamManagement() {
    const {t} = useTranslation()
    const {sessionContext} = useSessionContext()
    const {teamContext} = useTeamContext()
    const {mutateTeam} = useTeam(sessionContext.idTeam)
    let navigate = useNavigate()

    const deleteTeamUser = (value) => {
        return new Promise((resolve, reject) => {
            if (value) {
                const paramsRequest = {headers: {Authorization: `Bearer ${sessionContext.idToken}`}, data: [teamContext.isConfirmationModal.id]}
                axios.delete(`${API_TEAMS}/${sessionContext.idTeam}/users`, paramsRequest)
                .then(() => {
                    toast.success(t("Member deleted"))
                    mutateTeam()
                    resolve()
                })
                .catch((error) => {
                    console.error("error :", error)
                    reject()
                })
            } else {
                resolve()
            }
        })
    }

    useEffect(() => {
        sessionContext.role === "admin" && navigate("/neurowide-dashboard")
    }, [])

    return (
        <>
        <RequireIsManager role={sessionContext.role} redirect={true}>
            <div className="VIEW TEAM-MANAGEMENT">
                {teamContext.isConfirmationModal.modal && <ConfirmationModal type={"teams"} deleteTeamUser={deleteTeamUser}/>}
                <TeamManagementHeader/>
                <span className="line"></span>
                <TeamManagementContent/>
            </div>
        </RequireIsManager>
        </>
    )
}